module.exports = __webpack_public_path__ + "static/img/qrcode2017.36c6f1c4.jpg";